module.exports = __webpack_public_path__ + "img/SLOLPR.4d0e9972.svg";